import React from "react";
import { times } from "ramda";
import styled, { keyframes } from "styled-components";

const animation = keyframes`
  0%, 70%, 100% {
    transform: scale3D(1, 1, 1);
  }
  35% {
    transform: scale3D(0, 0, 1);
  } 
`;

const Item = styled.div`
  width: 33%;
  height: 33%;
  background-color: #333;
  float: left;
  animation: ${animation} 1.3s infinite ease-in-out;
`;

const Wrap = styled.div`
  width: 40px;
  height: 40px;
  margin: 0 auto;
  ${Item}:nth-child(1) {
    animation-delay: 0.2s;
  }
  ${Item}:nth-child(2) {
    animation-delay: 0.3s;
  }
  ${Item}:nth-child(3) {
    animation-delay: 0.4s;
  }
  ${Item}:nth-child(4) {
    animation-delay: 0.1s;
  }
  ${Item}:nth-child(5) {
    animation-delay: 0.2s;
  }
  ${Item}:nth-child(6) {
    animation-delay: 0.3s;
  }
  ${Item}:nth-child(7) {
    animation-delay: 0s;
  }
  ${Item}:nth-child(8) {
    animation-delay: 0.1s;
  }
  ${Item}:nth-child(9) {
    animation-delay: 0.2s;
  }
`;

export default () => (
  <div className="flex h-100 items-center justify-center">
    <Wrap>{times(i => <Item key={i} />, 9)}</Wrap>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/generic/kit/Loader/index.js